export default require('../otherChains/polygonZkevmCardona').default.rpcUrls.default.http[0]